import React from 'react';
import styled from 'styled-components';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { NgTooltip } from '../NgTooltip/NgTooltip';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.white};
  border: none;
  border-radius: 4px;
  padding: 3px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.textDimmed};
  line-height: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;

  &:hover {
    background: #f0f0f0;
    color: ${({ theme }) => theme.palette.textStrong};
  }

  svg {
    width: 13px;
    height: 13px;
  }
`;

interface NgPreviewButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  tooltip?: string;
}

export const NgPreviewButton: React.FC<NgPreviewButtonProps> = ({ onClick, tooltip = 'Preview' }) => (
  <NgTooltip title={tooltip} placement="top">
    <StyledButton type="button" onClick={onClick}>
      <VisibilityOutlinedIcon />
    </StyledButton>
  </NgTooltip>
);
